import styled from 'styled-components';

const Container = styled.div<{
  link?: string;
}>`
  display: grid;
  grid-template-columns: 5px 1fr;
  border-radius: 7px;
  border: 1px solid #e9e9e9;
  margin-bottom: 10px;
  flex: 1;
  font-family: ${(props) => props.theme.fonts.oswald};

  .colContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    ${(props) => props.link && `&:hover{opacity:0.8;cursor:pointer;}`}
  }

  .information-type {
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .information-origin {
    color: ${(props) => props.theme.colors['dark']};
  }

  .description-mobile {
    @media (max-width: 845px) {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
`;

// Added display : inline-table; because when lines were too long they would overlap with the next line
const Description = styled.span`
  font-family: ${(props) => props.theme.fonts.oswald_light};
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${(props) => props.theme.colors['dark']};
  display: inline-table;

  @media (min-width: 845px) {
    height: 21px;
  }

  & > a {
    color: ${(props) => props.theme.colors['dark']};
    opacity: 0.7;
  }
`;

const GridColumsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 100px;

  @media (max-width: 845px) {
    grid-template-columns: 1fr;
  }

  .spaceContent {
    padding: 15px 20px 15px 30px;

    @media (max-width: 845px) {
      padding: 10px 12px 10px 20px;
    }
  }

  .ant-typography {
    margin: 0;
  }

  .buttonShow {
    padding: 15px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default Container;
export { Description, GridColumsContainer };
